import { useState, useEffect } from "react";
import { queryNoteStatusForDoctor, queryWeeklyNoteStatusForDoctor, queryDailyNoteStatusForDoctor } from "../../../utils/functions";
import TotalStatus from "./TotalStatus";
import WeeklyStatus from "./WeeklyStatus";
import DailyStatus from "./DailyStatus";

export default function NoteStatus({ doctor_id, access_token, doctor_name }) {
  const [noteStatus, setNoteStatus] = useState(null);
  const [weeklyNoteStatus, setWeeklyNoteStatus] = useState(null);
  const [dailyNoteStatus, setDailyNoteStatus] = useState(null);

  const [openTotalModal, setOpenTotalModal] = useState(false);
  const [openWeeklyModal, setOpenWeeklyModal] = useState(false);
  const [openDailyModal, setOpenDailyModal] = useState(false);

  useEffect(() => {
    (async () => {
      setNoteStatus(await queryNoteStatusForDoctor(doctor_id))
      setWeeklyNoteStatus(await queryWeeklyNoteStatusForDoctor(doctor_id))
      setDailyNoteStatus(await queryDailyNoteStatusForDoctor(doctor_id))
    })()
  }, [])

  return (
    <>
      {noteStatus !== null ? (
        <>
          <button onClick={() => setOpenDailyModal(true)}>View</button>
          {openDailyModal && <DailyStatus dailyNoteStatus={dailyNoteStatus} setOpenTotalModal={setOpenTotalModal} setOpenWeeklyModal={setOpenWeeklyModal} setOpenDailyModal={setOpenDailyModal} openDailyModal={openDailyModal} openWeeklyModal={openWeeklyModal} openTotalModal={openTotalModal} doctor_name={doctor_name} access_token={access_token} />}
          {openTotalModal && <TotalStatus noteStatus={noteStatus} setOpenTotalModal={setOpenTotalModal} openTotalModal={openTotalModal} setOpenWeeklyModal={setOpenWeeklyModal} openWeeklyModal={openWeeklyModal} access_token={access_token} doctor_name={doctor_name} openDailyModal={openDailyModal} setOpenDailyModal={setOpenDailyModal} />}
          {openWeeklyModal && <WeeklyStatus weeklyNoteStatus={weeklyNoteStatus} setOpenTotalModal={setOpenTotalModal} openWeeklyModal={openWeeklyModal} setOpenWeeklyModal={setOpenWeeklyModal} access_token={access_token} doctor_name={doctor_name} openTotalModal={openTotalModal} openDailyModal={openDailyModal} setOpenDailyModal={setOpenDailyModal} />}
        </>
      ) : (
        <span className="w-6 h-6 border-2 border-dashed rounded-full animate-spin border-ktx-purple mx-auto"></span>
      )
      }
    </>
  )
}

